var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fetcher"},[_c('div',{staticClass:"counter"},[_vm._v(" Events: "+_vm._s(_vm.events.length)+" ")]),_c('div',{staticClass:"more",attrs:{"href":"#"},on:{"click":function($event){return _vm.loadMore()}}},[_vm._v(" more ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }